if ( !customElements.get('custom-product-options') ) {
    class CustomProductOptions extends HTMLElement {

        static apiServer = "https://oomph-management-engine.txtcon.io/api/public/v1/";
        static shopDomain = window.Shopify.shop;

        constructor() {
            super();

            this.loadingSkuData = false;
            this.originalSrc = "";
            this.originalSrcset = "";

            this.optionValueExclusionRules = [];
        }

        connectedCallback() {
            console.log( '[Custom Product Options] Added Element to the page.' );

            this.loadOptionValueExclusionRules();

            this.initCustomOptionChange();
            this.addEventListener( 'change', this.handleGlobalOptions.bind(this) );

            this.applyOptionValueExclusions();
            
            this.handleDirectChange();
        }

        initCustomOptionChange() {
            const inputsToTriggerChange = this.querySelectorAll( '.swatch-input' );
            const labelsToTriggerLabelChange = this.querySelectorAll( '.swatch-label' );

            for ( let i = 0; i < inputsToTriggerChange.length; i++ ) {
                inputsToTriggerChange[i].addEventListener( 'change' , this.handleOptionChange.bind( this ) );
            }

            for ( let i = 0; i < labelsToTriggerLabelChange.length; i++ ) {
                labelsToTriggerLabelChange[i].addEventListener( 'mouseover' , this.handleMouseOverLabel );
                labelsToTriggerLabelChange[i].addEventListener( 'mouseout' , this.handleMouseOutLabel.bind( this ) );
            }
        }

        loadOptionValueExclusionRules() {
            const dataEl = this.querySelector( '#option-values-exclusions-data' );

            if ( dataEl == null ) {
                return;
            }

            try {
                const data = JSON.parse( dataEl.textContent );

                if ( Array.isArray( data.rules ) ) {
                    this.optionValueExclusionRules = data.rules;
                }
            } catch ( error ) {
                console.error( '[Custom Product Options] Unable to load option value exclusion rules.', error );
            }

            return;
        }

        applyOptionValueExclusions() {
            const previouslyExcluded = this.querySelectorAll( '.options-list-value[data-option-value-excluded]' );

            for ( let i = 0; i < previouslyExcluded.length; i++ ) {
                previouslyExcluded[i].removeAttribute( 'data-option-value-excluded' );
                previouslyExcluded[i].removeAttribute( 'hidden' );
            }

            if ( this.optionValueExclusionRules.length <= 0 ) {
                return;
            }

            const selectedOptions = this.getSelectedOptions();

            for ( let i = 0; i < this.optionValueExclusionRules.length; i++ ) {
                const rule = this.optionValueExclusionRules[i];
                const trigger = rule.when_option_selected;

                if ( trigger == null ) {
                    continue;
                }

                const selectedEntryId = selectedOptions[ String( trigger.metaobject_definition_id ) ];

                const triggerIsSelected = ( String( selectedEntryId ) === String( trigger.metaobject_entry_id ) );
                if ( !triggerIsSelected ) {
                    continue;
                }

                const optionsToHide = rule.hide_options || [];
                for ( let j = 0; j < optionsToHide.length; j++ ) {
                    this.hideExcludedOption( optionsToHide[j] );
                }
            }

            this.selectAvailableOptions();

            return;
        }

        hideExcludedOption( exclusion ) {
            const definitionId = String( exclusion.metaobject_definition_id );
            const entryId = String( exclusion.excluded_metaobject_entry_id );

            const input = this.querySelector( `.swatch-input[data-definition-id="${definitionId}"][data-entry-id="${entryId}"]` );

            if ( input == null ) {
                return;
            }

            const optionItem = input.closest( '.options-list-value' );

            if ( optionItem == null ) {
                return;
            }

            optionItem.setAttribute( 'data-option-value-excluded', '' );
            optionItem.setAttribute( 'hidden', '' );

            return;
        }

        selectAvailableOptions() {
            const selectedInputs = this.querySelectorAll( '.swatch-input:checked' );

            for ( let i = 0; i < selectedInputs.length; i++ ) {
                const selectedInput = selectedInputs[i];
                const selectedItem = selectedInput.closest( '.options-list-value' );

                if ( selectedItem == null || !selectedItem.hasAttribute( 'data-option-value-excluded' ) ) {
                    continue;
                }

                const optionsList = selectedInput.closest( '.options-list' );

                if ( optionsList == null ) {
                    continue;
                }

                const availableInputs = optionsList.querySelectorAll( '.options-list-value:not([data-option-value-excluded]) .swatch-input' );

                if ( availableInputs.length <= 0 ) {
                    continue;
                }

                availableInputs[0].click();
            }

            return;
        }

        handleMouseOverLabel( e ) {
            try {
                const labelHovered = e.currentTarget;

                const potentialSelected = labelHovered.getAttribute( "data-potential-selected" ); 
                const radioWrapper = labelHovered.closest( ".option-radio-buttons" );
                const selectedOptionElLabel = radioWrapper.querySelector( "[data-selected-option]" );

                selectedOptionElLabel.innerHTML = potentialSelected;
            } catch ( error ) {
                console.error( error );
            }
        }

        handleMouseOutLabel( e ) {
            try {
                const labelHovered = e.currentTarget;
                const optionId = labelHovered.getAttribute( "data-option-for" ); 
                const selectedOptions = this.getSelectedOptions();
                const valueIdSelected = selectedOptions[ optionId ];

                const radioWrapper = labelHovered.closest( ".option-radio-buttons" );
                const selectedOptionElLabel = radioWrapper.querySelector( "[data-selected-option]" );
                const selectedOptionEl = radioWrapper.querySelector( `[data-entry-id="${valueIdSelected}"]` );
                
                selectedOptionElLabel.innerHTML = selectedOptionEl.getAttribute( "data-option-label" );
            } catch ( error ) {
                console.error( error );
            }
        } 

        handleGlobalOptions( e ) {
            // GLOBAL Change Event for the whole custom-product-options component
            if (!e.target.matches('.swatch-input')) return;

            this.loadingSkuData = true;

            // Find the checked inputs and log them
            const selectedOptions = this.getSelectedOptions();
            const optionCombo = {
                options: selectedOptions
            };

            const firstSelectedOption = this.getFirstSelectedOption();

            fetch( CustomProductOptions.apiServer + "products/" + this.dataset.productId + "/images", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify( {
                    option_combo: JSON.stringify( optionCombo ),
                    first_option: JSON.stringify( firstSelectedOption ),
                    shop: CustomProductOptions.shopDomain
                } )
            })
            .then( response => response.json() )
            .then( ( data ) => {
                this.updateSkuAndImage( data , selectedOptions );
            })
            .catch( error => {
                this.loadingSkuData = false;
                console.error( "Error fetching images:", error );
            });
        }

        handleDirectChange() {
            this.loadingSkuData = true;

            const selectedOptions = this.getSelectedOptions();
            const optionCombo = {
                options: selectedOptions
            };

            // dont fetch when no keys
            const keys = Object.keys( selectedOptions ).length;
            if ( keys <= 0 ) {
                this.loadingSkuData = false;
                return;
            }

            const firstSelectedOption = this.getFirstSelectedOption();

            fetch( CustomProductOptions.apiServer + "products/" + this.dataset.productId + "/images", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify( {
                    option_combo: JSON.stringify( optionCombo ),
                    first_option: JSON.stringify( firstSelectedOption ),
                    shop: CustomProductOptions.shopDomain
                } )
            })
            .then( response => response.json() )
            .then( ( data ) => {
                this.updateSkuAndImage( data , selectedOptions );
            })
            .catch( error => {
                this.loadingSkuData = false;
                console.error( "Error fetching images:", error );
            });
        }

        handleOptionChange( e ) {
            const changeInput = e.target;
            const customProductOptionContainer = changeInput.closest( "custom-product-options" );

            const changeEventRoute = changeInput.getAttribute( "data-change-event-type" );
            const optionToFind = changeInput.getAttribute( "data-option" );
            const valueSelected = changeInput.getAttribute( "value" );
            const view = changeInput.getAttribute( "data-view" );
            const valueAsLabel = changeInput.getAttribute( "data-option-label" );
            const productId = changeInput.getAttribute( "data-product-id" );

            let wrapperClass = ".main-product-section";
            if ( view == "quick-view" ) {
                wrapperClass = ".quickview-drawer"
            }

            if ( changeEventRoute == "no-shopify-option" ) {
                console.log( '[Custom Product Options] No shopify options to update.' );
            } 
            else if ( changeEventRoute == "base-custom" ) {
                console.log( '[Custom Product Options] Update related Base / Custom shopify option.' );

                let elToSelect = null
                if ( valueSelected == "com" || valueSelected == "custom" ) {
                    elToSelect = document.querySelector( `${wrapperClass} [data-product-id="${productId}"] [data-option-slug-backup="${optionToFind}"] [data-option-value-handle="custom"]` );
                } else {
                    elToSelect = document.querySelector( `${wrapperClass} [data-product-id="${productId}"] [data-option-slug-backup="${optionToFind}"] [data-option-value-handle="base"]` );
                }

                if ( elToSelect != null ) {
                    if ( elToSelect.tagName == "OPTION" ) {
                        const optionIndex = elToSelect.getAttribute( 'data-option-index' );
                        const select = elToSelect.closest('select');
                        if ( select != null ) {
                            select.selectedIndex = optionIndex;
                            select.dispatchEvent( new Event("change", { bubbles: true }) )
                        }
                    } else {
                        elToSelect.click();
                    }
                }
            } 
            else if ( changeEventRoute == "all-shopify-options" ) {
                console.log( '[Custom Product Options] Update related shopify option.' );

                const elToSelect = document.querySelector( `${wrapperClass} [data-product-id="${productId}"] [data-option-slug-backup="${optionToFind}"] [data-option-value-handle="${valueSelected}"]` );
                if ( elToSelect != null ) {
                    if ( elToSelect.tagName == "OPTION" ) {
                        const optionIndex = elToSelect.getAttribute( 'data-option-index' );
                        const select = elToSelect.closest('select');
                        if ( select != null ) {
                            select.selectedIndex = optionIndex;
                            select.dispatchEvent( new Event("change", { bubbles: true }) )
                        }
                    } else {
                        elToSelect.click();
                    }
                }
            }

            // update selected option label
            if ( customProductOptionContainer != null ) {
                const elToUpdate = customProductOptionContainer.querySelector(`[data-selected-option="${optionToFind}"]`);
                if ( elToUpdate != null ) {
                    elToUpdate.innerHTML = valueAsLabel;
                }
            }

            const optionWrapper = changeInput.closest('.c-p-o-wrapper');
            if ( optionWrapper != null ) {
                const showColorForm = optionWrapper.hasAttribute( "data-show-color-com" );
                const showFabricForm = optionWrapper.hasAttribute( "data-show-fabric-com" );
                const showTrimForm = optionWrapper.hasAttribute( "data-show-fabric-com" );

                const validLabels = [ "color", "fabric", "trim-welting" ];
                if ( validLabels.includes( optionToFind ) ) {
                    if ( valueSelected == "com" || valueSelected == "custom" ) {
                        if ( showColorForm || showFabricForm || showTrimForm ) {
                            this.showCustomVariationsForm( optionToFind );
                        }
                    } else {
                        this.hideCustomVariationForm( optionToFind );
                    }
                }

                
            }

            this.applyOptionValueExclusions();
        }

        getSelectedOptions() {
            const selectedOptions = {};
            const allOptionInputs = this.querySelectorAll('.swatch-input:checked');

            allOptionInputs.forEach( (input) => {
                const defId = input.dataset.definitionId;
                const entryId = input.dataset.entryId;
                selectedOptions[defId] = entryId;
            });

            return selectedOptions;
        }

        getFirstSelectedOption() {
            const selectedOptions = {};
            const allOptionInputs = Array.from(this.querySelectorAll('.swatch-input:checked')).slice(0,1);

            allOptionInputs.forEach( (input) => {
                const defId = input.dataset.definitionId;
                const entryIdRaw = input.dataset.entryId;
                const entryId = Number(entryIdRaw);
                selectedOptions[defId] = entryId;
            });

            return selectedOptions;
        }

        getSelectedOptionsAsProps() {
            const selectedOptions = {};
            const allOptionInputs = this.querySelectorAll('.swatch-input:checked');

            allOptionInputs.forEach( (input) => {
                const option = input.dataset.option;
                const optionValue = input.value;
                selectedOptions[option] = optionValue;
            });

            return selectedOptions;
        }

        updateSkuAndImage( data , selectedOptions ) {
            const partialMatchAlert = document.querySelector( "#partial-match-alert" );

            let exactMatch = false;
            if ( data.image_data && data.image_data.length > 0 ) {
                const returnedOptions = data.image_data[0].option_combo?.options || {};
                const selectedKeys = Object.keys( selectedOptions );

                exactMatch = selectedKeys.every( ( key ) => {
                    return String( selectedOptions[key] ) === String( returnedOptions[key] );
                });
            }

            if ( partialMatchAlert != null ) {
                if ( exactMatch ) {
                    partialMatchAlert.classList.add( "hidden" );
                } else {
                    partialMatchAlert.classList.remove( "hidden" );
                }
            }

            // console.log( "Image data response:", data );

            const view = this.getAttribute('data-view');
            const skuValueField = this.querySelector(`#selected-sku-${view}`);

            let wrapperClass = ".main-product-section";
            if ( view == "quick-view" ) {
                wrapperClass = ".quickview-drawer";
            }

            if ( data.sku_data && data.sku_data.length > 0 ) {
                for ( let i = 0; i < data.sku_data.length; i++ ) {
                    // console.log( "SKU:", data.sku_data[i].sku );
                    if ( skuValueField != null ) {
                        skuValueField.innerHTML = data.sku_data[i].sku;
                        skuValueField.setAttribute( "value" , data.sku_data[i].sku );
                    }

                    break;
                }
            }

            const sectionEl = this.closest( wrapperClass );
            const mainMediaElWrapper = sectionEl.querySelector( ".main-product-featuredmedia [data-media-id]" );
            const mainMediaScrollable = sectionEl.querySelector( ".main-product-scrollingmedia" );

            let mainMediaEl = null;
            if ( mainMediaElWrapper != null ) {
               mainMediaEl = mainMediaElWrapper.querySelector( "img.media-image" );
            } else {
                // in quickview so do different step
            }
             
            const loadedAt = new Date().getTime();

            // remove any secondary images
            if ( mainMediaScrollable != null ) {
                const removalTargets = mainMediaScrollable.querySelectorAll( `[data-custom-added]` );
                for ( let i = 0; i < removalTargets.length; i++ ) {
                    removalTargets[i].remove();
                }
            }
            
            if ( data.image_data && data.image_data.length > 0 ) {
                for ( let i = 0; i < data.image_data.length; i++ ) {
                    let urlTemplate = `{{URL}}&width=1500`;
                    let srcsetTemplate = `
                        {{URL}}&width=600 600w, 
                        {{URL}}&width=700 700w, 
                        {{URL}}&width=800 800w, 
                        {{URL}}&width=900 900w, 
                        {{URL}}&width=1000 1000w, 
                        {{URL}}&width=1200 1200w, 
                        {{URL}}&width=1400 1400w,
                        {{URL}}&width=1500 1500w
                    `;

                    // get urls
                    const baseURL = data.image_data[i].image_cdn_url;
                    
                    // IF AWS or Missing the ? in the url, use different template
                    const isS3 = baseURL.includes('amazonaws.com');
                    const hasQueryParams = baseURL.includes('?');

                    if ( isS3 || !hasQueryParams ) {
                        urlTemplate = `{{URL}}`;
                        srcsetTemplate = `
                            {{URL}} 600w, 
                            {{URL}} 700w, 
                            {{URL}} 800w, 
                            {{URL}} 900w, 
                            {{URL}} 1000w, 
                            {{URL}} 1200w, 
                            {{URL}} 1400w,
                            {{URL}} 1500w
                        `;
                    }
                    urlTemplate = urlTemplate.replaceAll( "{{URL}}" , baseURL );
                    srcsetTemplate = srcsetTemplate.replaceAll( "{{URL}}" , baseURL );

                    if ( i == 0 && sectionEl != null && mainMediaEl != null ) {
                        if ( this.originalSrc == "" ) {
                            this.originalSrc = mainMediaEl.getAttribute( "src" );
                        } 
                        
                        if ( this.originalSrcset == "" ) {
                            this.originalSrcset = mainMediaEl.getAttribute( "srcset" );
                        }

                        mainMediaEl.setAttribute( "src" , urlTemplate );
                        mainMediaEl.setAttribute( "srcset" , srcsetTemplate );
                    } else if ( sectionEl != null && i > 0 ) {
                        if ( mainMediaScrollable != null ) {
                            const slideCount = mainMediaScrollable.querySelectorAll( '.product-media' ).length;

                            const newImage = document.createElement( "div" );
                            newImage.classList.add( "product-media" , "media-wrapper" );
                            newImage.setAttribute( "data-media-item" , "" );
                            newImage.setAttribute( "data-custom-added" , loadedAt );
                            newImage.setAttribute( "data-index" , slideCount + 1 );
                            newImage.setAttribute( "data-media-id" , i );

                            const innerHTML = `
                                <div class="media" style="--image-ratio: 100%" data-source="main-product">
                                    <lightbox-viewer data-section="${sectionEl.id.replace("shopify-section-" , "")}"></lightbox-viewer>
                                     <img 
                                        src="${urlTemplate}" 
                                        alt="Image for current product ${i}" 
                                        srcset="${srcsetTemplate}" 
                                        width="1500" 
                                        height="1500" 
                                        loading="eager" 
                                        class="media-image" 
                                        sizes="100vw" 
                                        fetchpriority="high" 
                                        style="object-position:center;"
                                    >
                                </div>
                            `;

                            newImage.innerHTML = innerHTML;
                            
                            mainMediaScrollable.prepend( newImage );
                        }   
                    }
                }
            } else {
                // reset back to original assuming we have changed it at least once
                if ( this.originalSrc != "" && this.originalSrcset != null ) {
                    if ( mainMediaEl != null ) {
                        mainMediaEl.setAttribute( "src" , this.originalSrc );
                        mainMediaEl.setAttribute( "srcset" , this.originalSrcset );
                    }
                }
            }

            this.loadingSkuData = false;
        }

        showCustomVariationsForm( label ) {
            const wrapper = this.closest( '.product-info-inner' );

            if ( !wrapper ) {
                return;
            }

            const form = wrapper.querySelector( ".custom-variation-form" );
            const atcButton = wrapper.querySelector( ".custom-atc-btn" );

            if ( form ) {
                const colorContainer = form.querySelector( ".color-container" );
                const fabricContainer = form.querySelector( ".fabric-container" );
                const trimContainer = form.querySelector( ".trim-fabric-container" );

                form.classList.remove( "hide" );

                if ( label === "color" ) {
                    colorContainer.classList.toggle( "hide" );
                    this.enableRequiredInputs( colorContainer );

                    const comTitle = wrapper.querySelector( ".com-title" );
                    comTitle.textContent = ""
                    comTitle.textContent = "Custom Color Requirements:";

                    const comDescrip = wrapper.querySelector( ".com-description" );
                    comDescrip.textContent = "";
                    comDescrip.textContent = "Please Enter Your Color Information";

                    if ( !this.areRequiredFieldsFilled( colorContainer ) ) {
                        this.toggleATCButton( atcButton , false );
                    }
                } else if ( label === "fabric" ) {
                    fabricContainer.classList.toggle( "hide" );
                    this.enableRequiredInputs( fabricContainer );

                    if ( !this.areRequiredFieldsFilled( fabricContainer ) ) {
                        this.toggleATCButton( atcButton , false );
                    }
                } else if ( label === "trim-welting" ) {
                    trimContainer.classList.toggle( "hide" );
                    this.enableRequiredInputs( trimContainer );

                    if ( !this.areRequiredFieldsFilled( trimContainer ) ) {
                        this.toggleATCButton( atcButton , false );
                    }
                }
            }
        }

        hideCustomVariationForm( label ) {
            const wrapper = this.closest( '.product-info-inner' );

            if ( !wrapper ) {
                return;
            }

            const form = wrapper.querySelector( ".custom-variation-form" );
            const atcButton = wrapper.querySelector( ".custom-atc-btn" );
            
            if ( form ) {
                const colorContainer = form.querySelector( ".color-container" );
                const fabricContainer = form.querySelector( ".fabric-container" );
                const trimContainer = form.querySelector( ".trim-fabric-container" );

                if ( label === "color" ) {
                    colorContainer.classList.add( "hide" );
                    this.disableRequiredInputs( colorContainer );
                } else if ( label === "fabric" ) {
                    fabricContainer.classList.add( "hide" );
                    this.disableRequiredInputs( fabricContainer );
                } else if ( label === "trim-welting" ) {
                    trimContainer.classList.add( "hide" );
                    this.disableRequiredInputs( trimContainer );
                }

                const anyVisible = !colorContainer.classList.contains( "hide" ) || !fabricContainer.classList.contains( "hide" ) || !trimContainer.classList.contains( "hide" );

                if ( !anyVisible ) {
                    form.classList.add( "hide" );
                    this.toggleATCButton( atcButton , true );
                } else {
                    if ( !trimContainer.classList.contains( "hide" ) && !this.areRequiredFieldsFilled( trimContainer ) ) {
                        this.toggleATCButton( atcButton , false );
                    }

                    if ( !colorContainer.classList.contains( "hide" ) && !this.areRequiredFieldsFilled( colorContainer ) ) {
                        this.toggleATCButton( atcButton , false );
                    }

                    if ( !fabricContainer.classList.contains( "hide" ) && !this.areRequiredFieldsFilled( fabricContainer ) ) {
                        this.toggleATCButton( atcButton , false );
                    }
                }
            }
        }

        disableRequiredInputs(container) {
            if ( !container ) return;

            const inputs = container.querySelectorAll( 'input, textarea' );
            const filteredInputs = Array.from( inputs ).filter( el => !el.closest( "uc-file-uploader-regular" ) );

            for ( let i = 0; i < filteredInputs.length; i++ ) {
                const input = filteredInputs[ i ];
                input.disabled = true;
                input.required = false;
            }
        }

        enableRequiredInputs(container) {
            if ( !container ) return;

            const inputs = container.querySelectorAll( 'input, textarea' );
            const filteredInputs = Array.from( inputs ).filter( el => !el.closest( "uc-file-uploader-regular" ) );

            for ( let i = 0; i < filteredInputs.length; i++ ) {
                const input = filteredInputs[ i ];
                input.disabled = false;
                input.required = true;
            }
        }

        areRequiredFieldsFilled( section ) {
            const requiredFields = section.querySelectorAll( "[required]" );
            for ( let field of requiredFields ) {
                if ( field.type === "text" && !field.value ) {
                    return false;
                }

                if ( field.type === "radio" && !section.querySelector( `input[name="${field.name}"]:checked` ) ) {
                    return false;
                }
            }

            return true;
        }

        toggleATCButton( button , enabled ) {
            if ( !button ) {
                return;
            }

            const shouldEnabled = ( enabled === true );
            if ( shouldEnabled ) {
                button.removeAttribute( "disabled" );
                button.classList.remove( "com-form-disabled" );
            } else {
                button.setAttribute( "disabled" , "true" );
                button.classList.add( "com-form-disabled" );
            }
        }
    }

    customElements.define( 'custom-product-options', CustomProductOptions );
}